/**
 * Returns true when qty triggers the "Omdoos-korting" — only on exact multiples
 * of box_qty (75, 150, 225, ...). 76 stuks = no discount (1 full box + 1 loose).
 */
export function qtyMatchesFullBoxes(qty, boxQty) {
  if (!boxQty || boxQty < 2) return false;
  if (qty < boxQty) return false;
  return qty % boxQty === 0;
}

/** Effective per-piece price honouring the multiples-only Omdoos-korting rule. */
export function effectiveUnitPrice({ piece_price, box_unit_price, box_qty }, qty) {
  if (qtyMatchesFullBoxes(qty, box_qty) && box_unit_price != null) {
    return box_unit_price;
  }
  return piece_price;
}

/** How many extra pieces the customer needs to reach the next full omdoos. */
export function piecesUntilNextBox(qty, boxQty) {
  if (!boxQty || boxQty < 2) return null;
  if (qty < boxQty) return boxQty - qty;
  const remainder = qty % boxQty;
  if (remainder === 0) return null;          // already aligned
  return boxQty - remainder;
}
